@if (!browserSniffer.isPhone()) {
<div class="trace-select-button-container">
    <button mat-mini-fab 
            disableRipple="true" 
            class="neutral-button map-control-button" 
            id="traceSelectButton" 
            aria-label="Route" 
            (click)="toggle()"
            [matTooltip]="(traceService.hasRouteOnMap()) ? (traceService.isWatchingRouteWithoutDrawer() ? ('trace.show-info' | translate ): 'trace.hide-info' | translate  ) : 'trace.title' | translate "
            matTooltipPosition="left">
        <!-- todo variable functions -->
        <mat-icon fontSet="ngi" [fontIcon]="buttonFontIcon ? buttonFontIcon : 'route-view'"
            matBadge="&#8288;" 
            matBadgeSize="small"
            matBadgePosition="above after"
            [matBadgeHidden]=" (!traceService.isInEditingMode() && !traceService.isInViewMode())"></mat-icon>
    </button>
    <!-- !traceService.isWatchingRouteWithoutDrawer() || -->
</div>
}
        <!-- [ngClass]="{'active': isOpen() || traceService.hasRouteOnMap() }" -->
<!-- 
   
 -->
<!-- matBadge="&#8288;"  -->

<!-- [color]="(traceService.isWatchingRouteWithoutDrawer() && (traceService.hasRouteOnMap))?'accent':''"  -->
<!-- (click)="traceService.isInEditingMode()? openTraceDrawer('CREATE_ROUTE'): openTraceDrawer('VIEW_ROUTE')" -->

<div class="tt-trace-drawer" [class.isOpen]="isOpen()" >
    <!-- *ngIf="!browserSniffer.isPhone" -->
    <!-- <tt-drawing-tools ></tt-drawing-tools> -->

    <!-- class="tt-trace-drawer-inner" -->
    <button matIconButton type="button" class="close" (click)="close()" [matTooltip]="'trace.close-panel' | translate">
        <mat-icon>arrow_forward</mat-icon>
    </button>

    <!-- (selectedIndexChange)="switchTabTypeInit($event.index, hideTraceCreate)" -->
    <mat-tab-group #tabgroup preserveContent="true" [selectedIndex]="traceService.tabindex()" (selectedTabChange)="switchTabType($event.index, hideTraceCreate, hideSuggestions)" 
        headerPosition="above" animationDuration="250ms" disablePagination="true" [class]="{'hideTraceCreate':hideTraceCreate, 'hideSuggestions': hideSuggestions}">
        
        <mat-tab [labelClass]="hideSuggestions?['hideTab']:[]"><!--  *ngIf="!browserSniffer.isPhone" -->
            <ng-template mat-tab-label>
                <a [matTooltip]="'trace.tab-tip-suggestions' | translate ">
                    <mat-icon fontSet="ngi" [fontIcon]=" suggestionsTabFontIcon ? suggestionsTabFontIcon : 'walk'"></mat-icon>
                    <span>{{'trace.route_suggestions'|translate}}</span>
                </a>
            </ng-template>
            <!-- class tab-viewport is used by HostListener touchstart -->
            <div class="tab-viewport">
                <tt-trace-suggestions [ngClass]="suggestionsPanelClass" [suggestionsTabTitleI8nKey]="suggestionsTabTitleI8nKey ? suggestionsTabTitleI8nKey : ''" ></tt-trace-suggestions>
            </div>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <a [matTooltip]="'trace.tab-tip-import' | translate ">
                    <mat-icon fontSet="ngi" fontIcon="route-upload"></mat-icon>
                    <span>{{"trace.route_upload"|translate}}</span>
                </a>
            </ng-template>
            <div class="tab-viewport">
                <tt-trace-import></tt-trace-import>
            </div>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <a [matTooltip]="'trace.tab-tip-view' | translate ">
                    @if(traceService.isInViewMode()) {
                         <mat-icon fontSet="ngi" fontIcon="route-view" matBadge="&#8288;" matBadgeSize="small" matBadgePosition="above after"></mat-icon>
                    } @else {
                        <mat-icon fontSet="ngi" fontIcon="route-view"></mat-icon>                    }
                    <span>{{"trace.route_view"|translate}}</span>
                </a>
            </ng-template>
            <!-- class tab-viewport is used by HostListener touchstart -->
            <div class="tab-viewport">
                <tt-trace-view [hideTraceCreate]="hideTraceCreate ? 'true' : 'false' "></tt-trace-view>
            </div>
        </mat-tab>

        <mat-tab [labelClass]="hideTraceCreate?['hideTab']:[]"><!--  *ngIf="!browserSniffer.isPhone" -->
            <ng-template mat-tab-label>
                <a [matTooltip]="'trace.tab-tip-draw' | translate ">
                    <mat-icon fontSet="ngi" fontIcon="route-draw"></mat-icon>
                    <span>{{"trace.route_draw"|translate}}</span>
                </a>
            </ng-template>
            <!-- class tab-viewport is used by HostListener touchstart -->
            <div class="tab-viewport">
                <tt-trace-create #traceCreate></tt-trace-create>
            </div>
        </mat-tab>

        <!-- 
        not using the close button anymore
        <mat-tab disabled="true" style="background-color: yellow;">
            <ng-template mat-tab-label>
                <div (click)="shutDown($event);" [matTooltip]="'trace.tab-tip-shutdown' | translate " class="shutdown-tab">
                    <mat-icon>close</mat-icon>
                    <span>{{"trace.route_quit"|translate}}</span>
                </div>
            </ng-template>
        </mat-tab>
        -->

    </mat-tab-group>
    <div class="trace-footer"></div>
</div>